import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { ArthaLogo, SunflowerGlyph } from "@/components/ArthaLogo";
import { Field } from "./Login";
import { toast } from "sonner";

const Signup = () => {
  const nav = useNavigate();
  const { signup } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "", company: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    setLoading(true);
    try {
      await signup(form);
      toast.success("Welcome to Artha");
      nav("/app/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-surface-app text-ink-body">
      <div className="p-8 md:p-16 flex flex-col">
        <Link to="/" data-testid="auth-logo-link"><ArthaLogo size={28} /></Link>
        <div className="my-auto max-w-md w-full">
          <div className="text-xs uppercase tracking-[0.28em] text-ink-muted font-mono-accent mb-6">Create account</div>
          <h1 className="h-display text-5xl md:text-6xl">Let's <span className="italic text-artha-amber">begin</span>.</h1>
          <form onSubmit={submit} className="mt-10 space-y-5" data-testid="signup-form">
            <Field label="Full name" id="name" value={form.name} onChange={set("name")} />
            <Field label="Work email" id="email" type="email" value={form.email} onChange={set("email")} />
            <Field label="Password (min 6)" id="password" type="password" value={form.password} onChange={set("password")} />
            <Field label="Company (optional)" id="company" value={form.company} onChange={set("company")} />
            <button type="submit" disabled={loading}
              data-testid="signup-submit-button"
              className="w-full bg-artha-ink text-artha-cream py-4 text-sm tracking-tight hover:bg-artha-amber hover:text-ink-body transition-colors disabled:opacity-60">
              {loading ? "Creating account…" : "Create account"}
            </button>
          </form>
          <p className="mt-6 text-sm text-ink-muted">
            Already a member? <Link to="/login" className="amber-link" data-testid="auth-login-link">Sign in →</Link>
          </p>
        </div>
      </div>
      <div className="hidden lg:flex bg-artha-ink relative overflow-hidden items-center justify-center">
        <div className="absolute inset-0 grain" />
        <div className="relative z-10 text-center">
          <SunflowerGlyph size={280} />
          <div className="mt-10 text-artha-cream/60 font-serif-display text-2xl italic max-w-xs mx-auto">
            Seven jurisdictions. <span className="text-artha-amber">One account.</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
